module.exports = __webpack_public_path__ + "static/tartu-university-e8affec8f1b83dc41ab46ab22d3807f3.png";